/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

export enum PackageCategory {
    General = 'general',
    Main = 'main',
    School = 'school',
    SchoolTrophy = 'school_trophy',
    MegaFunSchool = 'megafun_school',
    Ferien = 'ferien',
    FerienPass = 'ferienpass',
    FerienPassB = 'ferienpass_b',
    Kinder = 'kinder',
    Season = 'season',
    Event = 'event',
    EventS = 'event_s',
    EventMegaFun = 'event_megafun',
    EventNonPlusUltra = 'event_nonplusultra',
    PolterabendMegaFun = 'polterabend_megafun',
    PolterabendNonPlusUltra = 'polterabend_nonplusultra',
    EventM = 'event_m',
    EventL = 'event_l',
    Profile = 'profile',
    Giftcard = 'giftcard',
    Yearly = 'yearly',
    ThreeTwo = 'three_two',
    Action = 'action',
    Others = 'others',
    All = 'all',
    MegaFun = 'mega_fun',
    GigaFun = 'giga_fun',
    NonPlusUltra = 'non_plus_ultra',
    HappyKids = 'happy_kids',
    HappyKidsPlus = 'happy_kids_plus',
	HappyParty = 'happy_party',
	HappyPartyPlus = 'happy_party_plus',
	HappyPartyVIP = 'happy_party_vip',
}

export const ValidPackageCategory = [
    PackageCategory.EventMegaFun,
    PackageCategory.EventNonPlusUltra,
    PackageCategory.PolterabendMegaFun,
    PackageCategory.PolterabendNonPlusUltra,
    PackageCategory.SchoolTrophy,
    PackageCategory.MegaFunSchool,
    PackageCategory.Kinder,
    PackageCategory.General,
    PackageCategory.MegaFun,
    PackageCategory.GigaFun,
    PackageCategory.NonPlusUltra,
    PackageCategory.HappyKids,
    PackageCategory.HappyKidsPlus,
    PackageCategory.HappyParty,
    PackageCategory.HappyPartyPlus,
    PackageCategory.HappyPartyVIP,
]